import React from 'react';
import { dayCellClass, DAY_LEGEND } from '../../utils/healthStyle';
import { weekdayInitial, dayFullLabel } from '../../utils/healthTime';

const CAT_LABEL = {
  AUDIO: 'audio', VIDEO: 'video', NETWORK: 'network', APP_LIFECYCLE: 'app',
  SCHEDULED_FEATURE: 'scheduled', CONTENT: 'content', ACTIONS: 'actions',
};
const STATUS_WORD = { ok: 'OK', recovered: 'recovered', problem: 'problem', offline: 'offline all day', unknown: 'no data' };

export function dayTooltip(d) {
  const counts = Object.entries(d?.counts ?? {})
    .filter(([, n]) => Number(n) > 0)
    .map(([k, n]) => `${CAT_LABEL[k] ?? k}: ${n}`);
  const status = d?.status ?? 'unknown';
  return `${d?.date ? dayFullLabel(d.date) : 'Unknown day'} — ${STATUS_WORD[status] ?? status}${counts.length ? ` (${counts.join(', ')})` : ''}`;
}

export function DayLegend() {
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1.5 text-[10px] text-text-muted" data-testid="day-legend">
      {DAY_LEGEND.map((l) => (
        <span key={l.status} className="inline-flex items-center gap-1">
          <span className={`inline-block w-2 h-2 rounded-sm ${dayCellClass(l.status)}`} />{l.label}
        </span>
      ))}
    </div>
  );
}

/** 7 cells (weekday initial under each; full date in tooltip), oldest first. */
export default function DayStrip({ days, legend = false }) {
  const list = Array.isArray(days) ? days : [];
  return (
    <div className="inline-block">
      <div className="inline-flex gap-1" data-testid="day-strip">
        {list.map((d, i) => (
          <span key={d?.date ?? i} className="inline-flex flex-col items-center gap-0.5" title={dayTooltip(d)}>
            <span
              data-status={d?.status ?? 'unknown'}
              className={`inline-block w-3.5 h-5 rounded-sm ${dayCellClass(d?.status)}`}
            />
            <span className="text-[9px] leading-none text-text-muted" data-testid="day-label">{weekdayInitial(d?.date)}</span>
          </span>
        ))}
      </div>
      {legend && <DayLegend />}
    </div>
  );
}
